<script lang="ts">
  import { fly } from 'svelte/transition';
  import { gallery } from '../lib/gallery.svelte';

  let items = $state<HTMLButtonElement[]>([]);

  // Keep the on-screen photo visible in the list (only when browsing its folder).
  $effect(() => {
    const i = gallery.listPhotos.findIndex((p) => p.id === gallery.listActiveId);
    items[i]?.scrollIntoView({ block: 'nearest' });
  });
</script>

<div class="listing">
  <header class="head">
    <h2>{gallery.listBreadcrumb.join(' › ')}</h2>
    <p>{gallery.listPhotos.length} photo{gallery.listPhotos.length === 1 ? '' : 's'}</p>
  </header>

  <div class="scroll">
    {#if gallery.listPhotos.length}
      {#key gallery.listPath}
        <ol in:fly={{ x: 16, duration: 220 }}>
          {#each gallery.listPhotos as photo, i (photo.id)}
            <li>
              <button
                bind:this={items[i]}
                class="row"
                class:active={photo.id === gallery.listActiveId}
                aria-current={photo.id === gallery.listActiveId ? 'true' : undefined}
                onclick={() => gallery.openPhoto(photo.id)}
              >
                {photo.title}
              </button>
            </li>
          {/each}
        </ol>
      {/key}
    {:else}
      <p class="empty">No photos in this folder.</p>
    {/if}
  </div>
</div>

<style>
  .listing {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  /* Names the folder the list below belongs to; stays put while the list scrolls. */
  .head {
    flex: none;
    padding: 0 0.85rem 0.6rem;
    border-bottom: 1px solid var(--panel-divider);
  }
  .head h2 {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.25;
    color: var(--fg);
    text-shadow: 0 1px 10px rgba(0, 0, 0, 0.55);
  }
  .head p {
    margin: 0.15rem 0 0;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--muted);
  }

  .scroll {
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  ol {
    list-style: none;
    margin: 0;
    padding: 0.4rem 0;
  }

  .row {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0.5rem 0.85rem;
    font-size: 0.9rem;
    line-height: 1.25;
    color: var(--muted);
    border-left: 2px solid transparent;
    text-shadow: 0 1px 10px rgba(0, 0, 0, 0.55);
    transition:
      color 0.15s var(--ease),
      background 0.15s var(--ease);
  }
  .row:hover {
    color: var(--fg);
    background: rgba(255, 255, 255, 0.05);
  }
  .row.active {
    color: var(--fg);
    border-left-color: var(--accent);
    background: rgba(255, 255, 255, 0.08);
    font-weight: 600;
  }

  .empty {
    padding: 1rem 0.85rem;
    color: var(--muted);
    font-size: 0.9rem;
  }
</style>
